import { render, staticRenderFns } from "./EstacaoTrabalho.vue?vue&type=template&id=c2833964&scoped=true&"
import script from "./EstacaoTrabalho.vue?vue&type=script&lang=js&"
export * from "./EstacaoTrabalho.vue?vue&type=script&lang=js&"
import style0 from "./EstacaoTrabalho.vue?vue&type=style&index=0&id=c2833964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2833964",
  null
  
)

export default component.exports